module.exports = __webpack_public_path__ + "files/65aa09e4b7dc338dc70ca013a50ef0fe.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/symbols-4.png
// module id = 1390
// module chunks = 59